// extracted by mini-css-extract-plugin
module.exports = {"cancellation-policy":"cancellation-policy__21dFP","header":"header__OqksY","body":"body__2XCh4","red":"red__2b5Tq","sp-only":"sp-only__2TZ9u"};